import { useRef, useEffect } from 'react';
import api from '../api';
import { useLang } from '../context/LangContext';

// Lichte WYSIWYG-editor (contentEditable). Geeft HTML terug via onChange.
// Afbeeldingen worden geüpload en als absolute publieke URL ingevoegd.
export default function RichTextEditor({ value, onChange, minHeight = 180, placeholder }) {
  const { t } = useLang();
  const ref = useRef(null);
  const fileRef = useRef(null);

  // DOM alleen bijwerken als de externe waarde afwijkt (voorkomt cursor-sprong bij typen).
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || '')) {
      ref.current.innerHTML = value || '';
    }
  }, [value]);

  const sync = () => onChange(ref.current.innerHTML);
  const exec = (cmd, arg) => { document.execCommand(cmd, false, arg); ref.current.focus(); sync(); };

  async function onPickImage(e) {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('image', file);
    try {
      const res = await api.post('/api/mail/images', fd);
      ref.current.focus();
      document.execCommand('insertHTML', false, `<img src="${res.data.url}" style="max-width:100%">`);
      sync();
    } catch {
      alert(t('editor_image_failed'));
    } finally {
      e.target.value = '';
    }
  }

  const Btn = ({ cmd, arg, icon, title }) => (
    <button type="button" className="btn btn-sm btn-outline-secondary" title={title}
      onMouseDown={e => e.preventDefault()} onClick={() => exec(cmd, arg)}>
      <i className={`bi ${icon}`} />
    </button>
  );

  return (
    <div className="border rounded">
      <div className="d-flex gap-1 p-1 border-bottom flex-wrap bg-light">
        <Btn cmd="bold"      icon="bi-type-bold"      title={t('editor_bold')} />
        <Btn cmd="italic"    icon="bi-type-italic"    title={t('editor_italic')} />
        <Btn cmd="underline" icon="bi-type-underline" title={t('editor_underline')} />
        <Btn cmd="insertUnorderedList" icon="bi-list-ul" title={t('editor_ul')} />
        <Btn cmd="insertOrderedList"   icon="bi-list-ol" title={t('editor_ol')} />
        <button type="button" className="btn btn-sm btn-outline-secondary" title={t('editor_link')}
          onMouseDown={e => e.preventDefault()}
          onClick={() => { const u = window.prompt('URL'); if (u) exec('createLink', u); }}>
          <i className="bi bi-link-45deg" />
        </button>
        <button type="button" className="btn btn-sm btn-outline-secondary" title={t('editor_image')}
          onMouseDown={e => e.preventDefault()} onClick={() => fileRef.current.click()}>
          <i className="bi bi-image" />
        </button>
        <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/gif,image/webp"
          className="d-none" onChange={onPickImage} />
      </div>
      <div ref={ref} contentEditable className="p-2" data-placeholder={placeholder}
        style={{ minHeight, outline: 'none' }} onInput={sync} suppressContentEditableWarning />
    </div>
  );
}
